import request from '@/utils/request'

export function getAnnouncementList(params) {
  return request({
    url: '/admin/announcement/list',
    method: 'get',
    params
  })
}

// 预估触达人数 + 各学校用量（发布确认框要用）
// body: { pubScope, schoolIds }
// resp: { userCount, schoolCount, allUserCount, schoolUserCounts }
export function reachAnnouncement(data) {
  return request({
    url: '/admin/announcement/reach',
    method: 'post',
    data
  })
}

export function createAnnouncement(data) {
  return request({
    url: '/admin/announcement',
    method: 'post',
    data
  })
}

export function updateAnnouncement(data) {
  return request({
    url: '/admin/announcement',
    method: 'put',
    data
  })
}

export function deleteAnnouncement(id) {
  return request({
    url: '/admin/announcement/' + id,
    method: 'delete'
  })
}

export function publishAnnouncement(id) {
  return request({
    url: '/admin/announcement/publish/' + id,
    method: 'put'
  })
}

export function getAnnouncementDetail(id) {
  return request({
    url: '/admin/announcement/' + id,
    method: 'get'
  })
}
